<!-- Spinner de chargement -->
<div *ngIf="!dataLoaded" class="fixed inset-0 flex items-center justify-center bg-white bg-opacity-80">

  <div class="text-center">
    <!-- Spinner personnalisé avec les couleurs de votre charte -->
    <div class="inline-block w-16 h-16 border-4 border-blue-200 rounded-full border-t-blue-800 animate-spin"></div>
    <p class="mt-4 text-lg font-medium text-blue-800">Chargement des données...</p>
  </div>
</div>


<div class="max-w-screen-xl p-6 mx-auto bg-white shadow-md rounded-xl" [class.opacity-50]="!dataLoaded">
  <h2 class="mb-6 text-2xl font-medium text-gray-800">Tableau de Bord</h2>

  <!-- Statistiques -->
  <div class="max-w-6xl p-4 mx-auto">
    <div class="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-4">
      <!-- Statistique 1 : Cartes d'inspection -->
      <div class="p-6 text-center bg-white border border-blue-200 shadow-sm rounded-xl">
        <h3 class="mb-2 text-xl font-semibold text-gray-800">Cartes d'inspection</h3>
        <p class="text-3xl font-bold text-gray-800">{{ dataLoaded ? badges : '-' }}</p>
      </div>

      <!-- Statistique 2 : Rapports d'inspection -->
      <div class="p-6 text-center bg-white border border-blue-200 shadow-sm rounded-xl">
        <h3 class="mb-2 text-xl font-semibold text-gray-800">Rapports d'inspection</h3>
        <p class="text-3xl font-bold text-gray-800">{{ dataLoaded ? certificatControls : '-' }}</p>
      </div>

      <!-- Statistique 3 : Cartes actives -->
      <div class="p-6 text-center bg-white border border-blue-200 shadow-sm rounded-xl">
        <h3 class="mb-2 text-xl font-semibold text-gray-800">Cartes actives</h3>
        <p class="text-3xl font-bold text-gray-800">{{ dataLoaded ? (totalBadgesActive ? totalBadgesActive : 0) : '-' }}
        </p>
      </div>

      <!-- Nouvelle statistique : Taux de conformité -->
      <div class="p-6 text-center bg-white border border-blue-200 shadow-sm rounded-xl">
        <h3 class="mb-2 text-xl font-semibold text-gray-800">Taux de conformité</h3>
        <p class="text-3xl font-bold text-gray-800">
          {{ dataLoaded ? (complianceRate/certificatControls*100 | number:'1.1-2') + '%' : '-' }}
        </p>
      </div>
    </div>
  </div>

  <!-- Filtres -->
  <div class="p-6 mt-8 bg-white border border-blue-200 shadow-sm rounded-xl">
    <div class="grid grid-cols-1 gap-4 md:grid-cols-5">
      <div>
        <label for="dateDebut" class="block mb-2 text-sm font-medium text-blue-800">Date Début</label>
        <input type="date" id="dateDebut" name="dateDebut" [(ngModel)]="dateDebut"
          class="bg-gray-50 border border-blue-200 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" />
      </div>
      <div>
        <label for="dateFin" class="block mb-2 text-sm font-medium text-blue-800">Date de Fin</label>
        <input type="date" id="dateFin" name="dateFin" [(ngModel)]="dateFin"
          class="bg-gray-50 border border-blue-200 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" />
      </div>
      <div *ngIf="inspections && inspections.length > 0">
        <label for="societe" class="block mb-2 text-sm font-medium text-blue-800">Partenaires</label>
        <select id="societe" [(ngModel)]="selectedInspection" name="societe"
          class="bg-gray-50 border border-blue-200 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
          <option value="-1">Sélectionner le partenaire</option>
          <option *ngFor="let societe of inspections" [value]="societe.id">{{ societe.nom }}</option>
        </select>
      </div>

      <div class="flex items-end">
        <button type="button" (click)="applyFilters()"
          class="w-full text-white bg-gray-800 hover:bg-blue-900 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2.5 text-center">
          Appliquer les filtres
        </button>
      </div>
    </div>
  </div>

  <!-- Graphiques -->
  <div class="grid grid-cols-1 gap-6 mt-6 md:grid-cols-2">
    <!-- Graphique 1: Évolution des inspections -->
    <div class="p-4 bg-white border border-blue-200 shadow-sm rounded-xl">
      <h3 class="mb-4 text-lg font-semibold">Évolution des inspections</h3>
      <div id="trend-chart">
        <apx-chart [series]="trendChart.series!" [chart]="trendChart.chart!" [dataLabels]="trendChart.dataLabels!"
          [stroke]="trendChart.stroke!" [xaxis]="trendChart.xaxis!" [yaxis]="trendChart.yaxis!"
          [grid]="trendChart.grid!" [title]="trendChart.title!">
        </apx-chart>
      </div>
    </div>

    <!-- Graphique 2: Répartition par type de véhicule -->
    <div class="p-4 bg-white border border-blue-200 shadow-sm rounded-xl">
      <h3 class="mb-4 text-lg font-semibold">Répartition par type de véhicule</h3>
      <div id="vehicle-type-chart">
        <apx-chart [series]="vehicleTypeChart.series!" [chart]="vehicleTypeChart.chart!"
          [labels]="vehicleTypeChart.labels!" [responsive]="vehicleTypeChart.responsive!"
          [colors]="vehicleTypeChart.colors!">
        </apx-chart>
      </div>
    </div>

    <!-- Graphique 3: Conformité par statut -->
    <div class="p-4 bg-white border border-blue-200 shadow-sm rounded-xl">
      <h3 class="mb-4 text-lg font-semibold">Conformité des inspections</h3>
      <div id="status-chart">
        <apx-chart [series]="statusChart.series!" [chart]="statusChart.chart!" [plotOptions]="statusChart.plotOptions!"
          [dataLabels]="statusChart.dataLabels!" [stroke]="statusChart.stroke!" [xaxis]="statusChart.xaxis!"
          [yaxis]="statusChart.yaxis!" [fill]="statusChart.fill!" [colors]="statusChart.colors!"
          [legend]="statusChart.legend!">
        </apx-chart>
      </div>
    </div>

    <!-- Graphique 4: Taux de conformité par catégorie -->
    <!-- <div class="p-4 bg-white border border-blue-200 shadow-sm rounded-xl"> -->
    <!-- <h3 class="mb-4 text-lg font-semibold">Évolution des rapports d'inspection par partenaire</h3>
      <div id="line-chart" class="mt-2">
        <apx-chart class="mt-5" [series]="lineChart.series!" [chart]="lineChart.chart!" [xaxis]="lineChart.xaxis!"
          [yaxis]="lineChart.yaxis!" [stroke]="lineChart.stroke!" [markers]="lineChart.markers!"
          [dataLabels]="lineChart.dataLabels!" [colors]="lineChart.colors!" [grid]="lineChart.grid!"
          [legend]="lineChart.legend!">
        </apx-chart>
      </div> -->
    <!-- </div> -->

    <!-- Graphique 5: Inspections par société (pleine largeur) -->
    <div class="col-span-2 p-4 bg-white border border-blue-200 shadow-sm rounded-xl">
      <h3 class="mb-4 text-lg font-semibold">Nombre d'inspections par société</h3>
      <div id="inspection-societe-chart">
        <apx-chart [series]="inspectionSocieteChart.series!" [chart]="inspectionSocieteChart.chart!"
          [plotOptions]="inspectionSocieteChart.plotOptions!" [dataLabels]="inspectionSocieteChart.dataLabels!"
          [xaxis]="inspectionSocieteChart.xaxis!" [yaxis]="inspectionSocieteChart.yaxis!"
          [colors]="inspectionSocieteChart.colors!" [tooltip]="inspectionSocieteChart.tooltip!"
          [grid]="inspectionSocieteChart.grid!" [legend]="inspectionSocieteChart.legend!">
        </apx-chart>
      </div>
    </div>
  </div>
  <div class="mt-8 bg-white border border-blue-200 shadow-sm rounded-xl">
    <div class="grid grid-cols-4 gap-6 p-6">
      <div>
        <label for="dateDebut"
          class="block mb-2 text-sm font-medium text-blue-800">Date
          Début</label>
        <input type="date" id="dateDebut" name="dateDebut"
          [(ngModel)]="dateDebut"
          class="bg-gray-50 border border-blue-200 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" />
      </div>
      <div>
        <label for="dateFin"
          class="block mb-2 text-sm font-medium text-blue-800">Date de
          Fin</label>
        <input type="date" id="dateFin" name="dateFin" [(ngModel)]="dateFin"
          class="bg-gray-50 border border-blue-200 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" />
      </div>
      <div>
        <button type="button" (click)="searchDataPerDate()"
          class="mt-7 flex items-center gap-2 text-white bg-gray-800 hover:bg-blue-900 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2.5 text-center">
          Rechercher
        </button>
      </div>
    </div>

    <!-- Graphique -->
    <div class="p-4">
      <apx-chart
        [series]="chartOptions.series!"
        [chart]="chartOptions.chart!"
        [dataLabels]="chartOptions.dataLabels!"
        [plotOptions]="chartOptions.plotOptions!"
        [yaxis]="chartOptions.yaxis!"
        [xaxis]="chartOptions.xaxis!"
        [stroke]="chartOptions.stroke!"
        [grid]="chartOptions.grid!"
        [fill]="chartOptions.fill!"
        [annotations]="chartOptions.annotations!"></apx-chart>
    </div>
  </div>
  <!-- Tableau des données -->
  <div class="mt-8 bg-white border border-blue-200 shadow-sm rounded-xl">
    <div class="p-6">
      <h3 class="mb-4 text-lg font-semibold">Détails des inspections</h3>

      <!-- Bouton de téléchargement multiple -->
      <div *ngIf="selectedInspections.length > 0" class="p-3 mb-4 border border-blue-200 rounded-lg bg-blue-50">
        <div class="flex items-center justify-between">
          <span class="text-sm font-medium text-blue-800">
            {{ selectedInspections.length }} élément(s) sélectionné(s)
          </span>
          <button (click)="downloadSelectedInspections()"
            class="flex items-center gap-2 px-4 py-2 text-sm font-medium text-center text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            Télécharger
          </button>
        </div>
      </div>

      <div class="flex justify-between mb-4">
        <div class="grid grid-cols-3 gap-2">
          <div class="relative">
            <input type="text" placeholder="Rechercher..." (input)="onInputChange($event)"
              class="bg-gray-50 border border-blue-200 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 ">
          </div>
          <div class="relative">
            <input type="date" name="dateDebut" (input)="onDateInputChange($event)"
              class="bg-gray-50 border border-blue-200 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" />
          </div>
          <div class="relative">
            <select (input)="onStatusChange($event)" name="status"
              class="bg-gray-50 border border-blue-200 text-gray-800 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
              <option value="-1">Toutes les fiches</option>
              <option value="conforme">Conforme</option>
              <option value="non-conforme">Non conforme</option>
            </select>
          </div>
        </div>

        <!-- Dropdown pour les options d'export -->
        <div class="relative inline-block text-left">
          <button type="button" (click)="toggleExportDropdown()"
            class="inline-flex justify-center items-center gap-2 text-white bg-green-600 hover:bg-green-700 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-4 py-2.5">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <span>Exporter Excel</span>
            <svg class="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </button>

          <!-- Menu dropdown -->
          <div *ngIf="showExportDropdown"
            class="absolute right-0 z-10 w-56 mt-2 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
            <div class="py-1">
              <button (click)="exportCurrentPageToExcel()"
                class="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                Exporter la page actuelle
                <span class="ml-auto text-xs text-gray-500">({{paginatedInspections.length}} éléments)</span>
              </button>
              <button (click)="exportAllDataToExcel()"
                class="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                </svg>
                Exporter toutes les données
                <span class="ml-auto text-xs text-gray-500">({{totalItems}} éléments)</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="overflow-x-auto">
        <table class="w-full text-sm text-left text-gray-800">
          <thead class="text-xs text-gray-700 uppercase bg-gray-100">
            <tr>
              <th scope="col" class="w-12 px-4 py-3">
                <input type="checkbox" [checked]="isAllSelected()" (change)="toggleSelectAll($event)"
                  class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2">
              </th>
              <th scope="col" class="px-4 py-3">N° ordre</th>
              <th scope="col" class="px-4 py-3">Date inspection</th>
              <th scope="col" class="px-4 py-3">Société</th>
              <th scope="col" class="px-4 py-3">Véhicule</th>
              <th scope="col" class="px-4 py-3">Statut</th>
              <th scope="col" class="px-4 py-3">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let inspection of paginatedInspections; let i=index" class="bg-white border-b hover:bg-gray-50"
              [class.bg-blue-50]="isSelected(inspection.id)">
              <td class="px-4 py-3">
                <input type="checkbox" [checked]="isSelected(inspection.id)"
                  (change)="toggleInspectionSelection(inspection.id)"
                  class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2">
              </td>
              <td class="px-4 py-3 font-medium">{{ i+1}}</td>
              <td class="px-4 py-3">{{ inspection.creationDate | date:'dd/MM/yyyy' }}</td>
              <td class="px-4 py-3">{{ inspection.societe }}</td>
              <td class="px-4 py-3">{{ inspection.vehicule?.numeroAssurance }}</td>
              <td class="px-4 py-3">
                <span [ngClass]="{
                  'bg-green-100 text-green-800': inspection.avisFavorable === true,
                  'bg-red-100 text-red-800': inspection.avisFavorable != true
                }" class="text-xs font-medium px-2.5 py-0.5 rounded">
                  {{ inspection.avisFavorable!=null && inspection.avisFavorable === true ? 'Conforme' : 'Non conforme'
                  }}
                </span>
              </td>
              <td class="px-4 py-3">
                <button (click)="generateReportAction(inspection.id)"
                  class="font-medium text-blue-600 hover:underline">Télécharger</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="flex items-center justify-between pt-4">
        <span class="text-sm font-normal text-gray-700">
          Affichage de <span class="font-semibold">{{ startIndex }}-{{ endIndex }}</span> sur <span
            class="font-semibold">{{ totalItems }}</span>
        </span>
        <div class="inline-flex space-x-2">
          <button (click)="previousPage()" [disabled]="currentPage === 1"
            class="flex items-center justify-center h-8 px-3 text-sm font-medium text-gray-800 bg-white border border-gray-300 rounded-lg hover:bg-gray-100">
            Précédent
          </button>
          <span *ngFor="let page of visiblePages" (click)="goToPage(page)" [ngClass]="{
              'bg-blue-50 text-blue-600 border-blue-300': currentPage === page,
              'bg-white text-gray-800 border-gray-300': currentPage !== page
            }" class="flex items-center justify-center h-8 px-3 text-sm font-medium border rounded-lg cursor-pointer">
            {{ page }}
          </span>
          <button (click)="nextPage()" [disabled]="currentPage === totalPages"
            class="flex items-center justify-center h-8 px-3 text-sm font-medium text-gray-800 bg-white border border-gray-300 rounded-lg hover:bg-gray-100">
            Suivant
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
